import React, { Component } from 'react'
import Collapsible from 'react-collapsible'
// import { translate } from '../../utils/useful'
// import FormViewer from '../FormViewer'
import LoaderButton from '../LoaderButton'
import DiagramComponent from '../views/diagram/DiagramComponent'
export default class SecondStep extends Component {
    state = {
        Rules: [
            {
                rules: 'تا ۲ ساعت قبل از شروع سانس می‌توانید بلیت خود را بدون کسر وجه کنسل کنید ، مبلغ آن به حساب کاربری شما در سینماتیکت واریز خواهد شد.'
            },
            {
                rules: 'پس از پرداخت آنلاین وجه،محل صندلی خود را انتخاب نمایید. در غیر اینصورت سینما تیکت مسئولیتی در قبال بلیت شما نخواهد داشت.'
            },
            {
                rules: 'فیلم در صورتی اکران میشود که حداقل ۵ بلیت فروش رفته باشد.'
            },
            {
                rules: 'برای دریافت بلیت خود ۱۵ دقیقه قبل از شروع سانس به گیشه یا کیوسک های سینماتیکت مراجعه فرمایید.'
            },
            {
                rules: 'کاربر موظف است اطلاعات شخصی واقعی و صحیح خود را در سایت وارد نماید. سایت سینماتیکت مسئولیتی در قبال هرگونه مشکل احتمالی که در اثر ارائه اطلاعات غلط از طرف کاربر به این سایت، ایجاد شده است، ندارد.'
            },
        ],
        isOpen: false



        // headers: [

        //     { type: 'MultiLevelInput', key: 'categories', col: '12', information: { label: 'Categories', type: 'api', startPoint: null, root: null, isSearchable: true, reference: 'parent', fields: { value: '_id', title: 'name', image: 'image', parent: 'parent' }, address: 'getAllCategory', filter: {}, body: { sort: { name: 1 } }, required: true }, hideComponent: true, showMain: false },

        //     { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Write down the Discription', required: false } },




        //     { key: 'colors', type: 'ListColorsInput', col: '12', information: { label: '{{lang}}Available Colors', type: 'api', startPoint: null, root: null, isSearchable: true, fields: { value: '_id', title: 'name', extra: 'hex' }, address: 'getColors', filter: {}, body: {}, required: true }, showMain: false },
        //     { key: 'sizes', type: 'SizesInput', col: '12', information: { label: '{{lang}}Available Sizes', type: 'api', startPoint: null, root: null, isSearchable: true, fields: { value: '_id', title: 'name', extra: 'options' }, address: 'getSizes', filter: {}, body: {}, required: true }, showMain: false },


        //     {
        //         type: 'AttributesLoaderInput',
        //         key: 'specifications',
        //         ref: 'categories',
        //         information: { label: '{{lang}}Specifications', inputClass: 'transparent-input', refKey: 'categories', type: 'api', fields: { value: '_id', title: 'title' }, address: 'getFilteredSpecifications', filter: {} },
        //         showMain: false,
        //         fullCol: true,
        //         col: '12',
        //         dependencies: [{
        //             refKey: 'categories',
        //             targetKey: 'specifications',
        //             conditions: {
        //                 root: {
        //                     id: 'root',
        //                     action: 'and',
        //                     conditions: {
        //                         1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: "1" } }
        //                     }
        //                 },
        //             },
        //             show: false,
        //             init: false,

        //             changeHeader: { key: 'information.refValue', value: '@data.categories', },

        //         }],

        //     },

        //     // { key: 'category', type: 'SelectInput', col: '6', information: { label: '{{lang}}Select category', items: [{ value: 'men', title: 'men' }, { value: 'women', title: 'women' }], type: 'local', placeholder: '{{lang}}Search the Category', required: false } },
        //     // { key: 'discount', type: 'TextInput', col: '6', information: { label: '{{lang}}Discount', placeholder: '{{lang}}Write down the discount', required: false } },
        //     // { key: 'specification1', type: 'TextInput', col: '6', information: { label: '{{lang}}Specification 1', placeholder: '{{lang}}Number 1', required: false } },
        //     // { key: 'specification2', type: 'TextInput', col: '6', information: { label: '{{lang}}Specification 2', placeholder: '{{lang}}Number 2', required: false } },
        //     // { key: 'specification3', type: 'TextInput', col: '6', information: { label: '{{lang}}Specification 3', placeholder: '{{lang}}Number 3', required: false } },
        //     // { key: 'values.phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone', placeholder: '{{lang}}Phone', required: true }, showMain: false },
        //     // { key: 'values.message', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Message', placeholder: '{{lang}}Write your Message.....', required: false }, showMain: false },

        // ],
    }
    // handleStep = () => {
    //     this.props.changePage('thirdstep', 2)
    // }

    // componentDidMount() {
    //     console.log('this.props.initData()', this.props.initData())
    // }

    changeCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    handleBackStep = () => {
        this.props.changePage('firststep', 0)
    }
    nextPage = () => {
        let data = this.form.getForm()
        console.log(data)
        if (data) {
            this.props.setData(data, (result, err) => {
                this.props.changePage('thirdstep', 2)
            })
        }
    }
    render() {
        return (
            <div className='flexcc w-100'>
                <div className='w-100' style={{}}>
                    {/* <FormViewer ref={el => this.form = el} initData={this.props.initData} headers={this.state.headers} theme={"modern"} inputClass={"modern-input"} /> */}
                    <div style={{ background: 'rgb(250, 250, 250)' }}>
                        <div>
                            <div style={{ background: '#' }}>
                                <p>

                                    Nov, 24 2022
                                </p>
                            </div>
                            <div></div>
                        </div>
                    </div>


                    {/* <LoaderButton
                        onClick={this.nextPage}
                        // isLoading={this.state.isLoading}
                        // text={translate('send')}
                        text='Next'
                        type={"Oval"}
                        className="mt-4 mb-3"
                        buttonStyle={{ outline: 'none', backgroundColor: '#252525', cursor: 'pointer', padding: '10px 50px', borderRadius: 50, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                        width={40}
                        height={40}
                        color={'#fff'}
                    /> */}

                    <div className='flexcc'>
                        <button className='mt-1 opacity-5' onClick={() => this.handleBackStep()}>
                            <p>Back</p>
                        </button>
                    </div>

                    {/* <LoaderButton
                        onClick={this.handleBackStep}
                        // isLoading={this.state.isLoading}
                        // text={translate('send')}
                        text='Back'
                        type={"Oval"}
                        className="mt-4 mb-3"
                        buttonStyle={{ outline: 'none', backgroundColor: '#252525', cursor: 'pointer', padding: '10px 50px', borderRadius: 50, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                        width={40}
                        height={40}
                        color={'#fff'}
                    /> */}
                </div>
            </div>
        )
    }
}
